import React from "react";
import classNames from "classnames";
export type Props = {
  label: string;
  className?: string;
  color?: "primary" | "success" | "warning" | "danger" | string;
};

export const Chip = ({ label, color, className = "" }: Props) => {
  const internalClassName = classNames("gpc__chip", {
    className,
    [color as string]: color,
  });

  return (
    <div className={internalClassName}>
      <span className="gpc__chip__label">{label}</span>
    </div>
  );
};

export default Chip;
